
import config from 'config'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
export const contactCountries = () => {
  const url = `${config.api.url}/api/ext/contact/countries?storeCode=${currentStoreView().virtualStoreCode}`
  return fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .then(json => {
      if ((json.result && json.result.message)) {
        throw new Error(JSON.stringify(json))
      } else {
        return json.result
      }
    })
}

export const saveAttachement = async attachment => {
  if (!attachment) return null
  let filename = ''
  let readerPromise = new Promise((resolve, reject) => resolve(null))
  if (attachment) {
    const extension = attachment.type.split('/')[1]
    filename = `watch_attachment.${extension}`
    readerPromise = new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(attachment)
      reader.onload = () => resolve(reader.result.split(',')[1])
    })
  }
  return readerPromise.then(base64 => {
    return {
      filename,
      mimetype: attachment.type,
      size: attachment.size,
      content: base64
    }
  })
}
